import { render, staticRenderFns } from "./OfficePayment.vue?vue&type=template&id=279205d7"
import script from "./OfficePayment.vue?vue&type=script&lang=js"
export * from "./OfficePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports